import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';

import { Page } from '@app/routes';
import {
  diamondLargeLightGrayIcon,
  teamLightGrayIcon,
  eyeLightGrayIcon,
  manDoingYogaLightGrayIcon,
} from '@app/assets';
import { useLazyGetTasksQuery } from '@app/store/slices/tasks/tasksApi';

type FooterLinkType = 'shop' | 'friends' | 'cognition' | 'tasks';

interface FooterLinkProps {
  type: FooterLinkType;
  onClick?: () => void;
}

const TYPE_MAP: Record<
  FooterLinkType,
  {
    path: string;
    icon: string;
    iconWidth: number;
  }
> = {
  shop: {
    path: Page.SHOP,
    icon: diamondLargeLightGrayIcon,
    iconWidth: 26,
  },
  friends: {
    path: Page.FRIENDS,
    icon: teamLightGrayIcon,
    iconWidth: 29,
  },
  cognition: {
    path: Page.COGNITION,
    icon: eyeLightGrayIcon,
    iconWidth: 29,
  },
  tasks: {
    path: Page.TASKS,
    icon: manDoingYogaLightGrayIcon,
    iconWidth: 25,
  },
};

export function FooterLink({ type, onClick }: FooterLinkProps) {
  const { t } = useTranslation();
  const [triggerTasks, { data: tasksData }] = useLazyGetTasksQuery();

  useEffect(() => {
    triggerTasks();
  }, []);

  const { path, icon, iconWidth } = TYPE_MAP[type];

  return (
    <NavLink
      to={path}
      end
      className={({ isActive }) =>
        `flex flex-1 flex-col items-center gap-[5px] ${isActive ? 'opacity-100' : 'opacity-50'}`
      }
      onClick={onClick}
    >
      <div className="relative">
        <img src={icon} alt={path.slice(1)} width={iconWidth} />
        {tasksData?.hasRewardableTasks && type === 'tasks' && (
          <div className="absolute -top-1 right-0 size-2 animate-pulse rounded-full bg-red-500" />
        )}
      </div>
      <span
        className="theme-transition font-inter text-2xs font-medium leading-[18px]"
        style={{
          color: '#d4d4d4',
        }}
      >
        {t(`bottom_navigations.${type}`)}
      </span>
    </NavLink>
  );
}
